(function() {
    'use strict';

    angular
        .module('app.periodos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/periodos',
                config: {
                    templateUrl: 'app/periodos/periodos.html',
                    controller: 'Periodos',
                    controllerAs: 'vm',
                    title: 'Periodos',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/editar-periodo/:id?',
                config: {
                    templateUrl: 'app/periodos/editarPeriodo.html',
                    controller: 'EditarPeriodo',
                    controllerAs: 'vm',
                    title: 'EditarPeriodo',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            }
        ];
    }
})();
